export enum ApplicationType {
  Acceleration = 'Akceleracja',
  Incubation = 'Inkubacja',
  AccelerationAndIncubation = 'Inkubacja / Akceleracja',
}
